import React, { useState, useEffect, useRef } from "react";
import enableTableSearch from "../utility/table";
import ExportCSV from "./ExportCSV";
import API_BASE_URL from "../config";

function PropsTable({ reload }) {
  const [props, setProps] = useState([]);
  const inputRef = useRef();
  const tableRef = useRef();

  useEffect(() => {
    fetch(API_BASE_URL + "/api/props")
      .then((res) => res.json())
      .then((data) => setProps(data.props))
      .catch((err) => console.error("Error fetching props:", err));
  }, [reload]);

  useEffect(() => {
    const cleanup = enableTableSearch({
      inputRef,
      tableRef,
      columnIndex: 1,
      noDataText: "No props found",
    });

    return cleanup;
  }, []);

  return (
    <div id="table-container">
      <div id="header">
        <p>Props List</p>
      </div>
      <hr />
      <div id="table-actions">
        <ExportCSV
          entries={props.map((item, index) => [item.type])}
          header={["TYPE"]}
        />
        <div className="search-box">
          <label>Search:</label>
          <input type="text" id="search" name="search" ref={inputRef} />
        </div>
      </div>
      <table>
        <thead>
          <tr>
            <th>SL NO.</th>
            <th>TYPE</th>
          </tr>
        </thead>
        <tbody id="table-body" ref={tableRef}>
          {props.map((item, index) => (
            <tr key={item.id}>
              <td>{item.id}</td>
              <td>{item.type}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default PropsTable;
